import ApiConnector from "../apiConnector";

class CalendarDataFetcher {
  private readonly apiConnector: ApiConnector;

  constructor(baseURL: string) {
    this.apiConnector = new ApiConnector(baseURL);
  }

  public async getCalendarReport(year: number, month: number, userId: string): Promise<any> { 
    return await this.apiConnector.get<any>(`calendar/${year}/${month}/${userId}`);
  }
}

export default CalendarDataFetcher;